import { UploadData } from '../../../../store/uploadStore';
import { UploadNotRestoredError } from '../../../../errors/UploadNotRestoredError';
import { mapUploadTypeToMetricsEntityType } from '../../../../libs/metrics/metricUtils';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

const uploadTimers = new Map<object, number>();

export const trackUploadStart = (upload: UploadData) => {
  // upload.queue is a stable object
  const key = upload.queue;

  if (!uploadTimers.has(key)) {
    uploadTimers.set(key, Date.now());
  }
};

// @TODO
// Our UI allows to add a few photos at a time, so this can lead to multiple "short" uploads of the same site
// if the queue is cleared before the user adds more photos (or during interruptions)
// Do we care about this? Should we use 5 minute timeout windows here etc?
export const sendUploadTimeSeconds = (upload: UploadData) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const key = upload.queue;

  if (uploadTimers.has(key)) {
    const startTime = uploadTimers.get(key)!;
    const uploadTime = Date.now() - startTime;

    uploadTimers.delete(key);

    if (uploadTime) {
      const point = new Point();
      point.tag('Customer', upload.upload.customer);
      point.tag('Site', upload.upload.site);
      point.tag('EntityType', mapUploadTypeToMetricsEntityType(upload.meta.type));

      point.floatField('value', Number((uploadTime / 1000).toFixed(0)));

      influxWriter.send('UploadTimeSeconds', point);
    }
  }
};
